var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  overflow: hidden;\n  font-family: \"troika\", sans-serif;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  overflow: hidden;\n}\n\ncanvas {\n  width: 100%;\n  height: 100%;\n  cursor: crosshair;\n  background-color: #36441f;\n}\n\n@font-face {\n  font-family: 'troika';\n  font-style: normal;\n  font-weight: normal;\n  src: url(" + escape(require("./assets/troika.otf")) + ") format('opentype');\n}\n", ""]);

// exports
